import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Hl7viewerComponent } from './hl7viewer/hl7viewer.component';

export const routes: Routes = [
  { path: '', component: Hl7viewerComponent },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

